import { FormatDistanceFn, FormatDistanceLocale } from 'date-fns/types'

type FormatDistanceTokenValue =
  | string
  | {
      one: string
      other: string
    }

const formatDistanceLocale: FormatDistanceLocale<FormatDistanceTokenValue> = {
  lessThanXSeconds: {
    one: '<1 s',
    other: '<{{count}} s',
  },

  xSeconds: {
    one: '1 s',
    other: '{{count}} s',
  },

  halfAMinute: '30 s',

  lessThanXMinutes: {
    one: '<1 m',
    other: '<{{count}} min',
  },

  xMinutes: {
    one: '1 m',
    other: '{{count}} min',
  },

  aboutXHours: {
    one: '~1 h',
    other: '~{{count}} h',
  },

  xHours: {
    one: '1 h',
    other: '{{count}} h',
  },

  xDays: {
    one: '1 d',
    other: '{{count}} d',
  },

  aboutXWeeks: {
    one: '~1 w',
    other: '~{{count}} w',
  },

  xWeeks: {
    one: '1 w',
    other: '{{count}} w',
  },

  aboutXMonths: {
    one: '~1 mo',
    other: '~{{count}} mo',
  },

  xMonths: {
    one: '1 mo',
    other: '{{count}} mo',
  },

  aboutXYears: {
    one: '~1 y',
    other: '~{{count}} y',
  },

  xYears: {
    one: '1 y',
    other: '{{count}} y',
  },

  overXYears: {
    one: '>1 y',
    other: '>{{count}} y',
  },

  almostXYears: {
    one: '~1 y',
    other: '~{{count}} y',
  },
}

export const formatDistanceConciseLocale: FormatDistanceFn = (
  token,
  count,
  options,
) => {
  let result

  const tokenValue = formatDistanceLocale[token]
  if (typeof tokenValue === 'string') {
    result = tokenValue
  } else if (count === 1) {
    result = tokenValue.one
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString())
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}
